import authInstance from 'config/axios.config';

export const packageServices = {
  getPackages: async (filters) => {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== 'all' && value !== undefined && value !== null && value !== '') {
        params.append(key, String(value));
      }
    });

    const res = await authInstance.get(`/package?${params}`);
    return res.data;
  },

  getPackageById: async (packageId) => {
    const res = await authInstance.get(`/package/${packageId}`);
    return res.data;
  },

  addPackage: async (payload) => {
    const res = await authInstance.post('/package', payload);
    return res.data;
  },

  updatePackage: async ({ packageId, data }) => {
    const res = await authInstance.patch(`/package/admin/${packageId}`, data);
    return res.data;
  },

  deletePackage: async (packageId) => {
    const res = await authInstance.delete(`/package/${packageId}`);
    return res.data;
  },

  toggleActiveStatus: async (packageId) => {
    const res = await authInstance.patch(`/package/${packageId}/toggle-active`);
    return res.data;
  },

  uploadVideo: async (file) => {

  const formData =
    new FormData();

  formData.append(
    'file',
    file
  );


  const res =
    await authInstance.post(

      '/admin/upload',

      formData,

      {

        headers:{

          'Content-Type':

          'multipart/form-data'

        }

      }

    );


  return res.data;
},

exportPackages: async ({
  sellerId,
  isActive,
  isPopular,
  isFeatured,
  search,
  sortBy,
  sortOrder,
  type,
}) => {
  const params =
    new URLSearchParams({
      sellerId:
        sellerId || '',

      isActive:
        isActive === 'all'
          ? ''
          : isActive || '',

      isPopular:
        isPopular === 'all'
          ? ''
          : isPopular || '',

      isFeatured:
        isFeatured === 'all'
          ? ''
          : isFeatured || '',

      search:
        search || '',

      sortBy:
        sortBy || 'createdAt',

      sortOrder:
        sortOrder || 'desc',

      type:
        type || '',
    });

  for (const [key, value] of [
    ...params.entries(),
  ]) {
    if (!value) {
      params.delete(key);
    }
  }

  return authInstance.get(
    `/package/export?${params.toString()}`,
    {
      responseType: 'blob',
    }
  );
},
};
